import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../utils/redux/userSlice";
import MachineStatus from "../components/MachineStatusComponent/MachineStatus.component";
import { ISelectOptions } from "../utils/interfaces/ISelectOptions";
import { useOutletContext, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Instalation } from "../utils/models/Instalation";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { getInstalationsByCompany } from "../utils/services/instalation.service";
import { DashboardTypes, MachineConected } from "aw-consts";
import { getLast7days, getTodayDate } from "aw-date-functions";
import { getRandomNumber, orderByLabel } from "aw-generic-functions";
import { AwCarousel } from "aw-carousel";
import MachineCard from "../components/MachinesComponents/MachineCard/MachineCard.component";
import { AWGrid, TableData } from "aw-grid";
import CharD3, { charData } from "../components/CharProductionComponent/charD3.component";
import { format } from "date-fns";
import { Spinner } from "react-bootstrap";
import { MapComponent } from "aw-map";
import { Machine } from "../utils/models/Machine";
import { useTheme } from "../utils/contexts/ThemeContext";
import { UserButtonsLine } from "aw-user-buttons-line";

const UserInstalationsPage = () => {
    const user = useSelector(selectUser)
    const [instalations, setInstalations] = useState<Instalation[]>([])
    const [instalation, setInstalation] = useState<Instalation>(new Instalation())
    const [allInstalationsObj, setAllInstalationsObj] = useState<ISelectOptions[]>([])
    // Helper to enforce value:number
    type AnySelectOption = { label: string; value: string | number };
    const setAllInstalationsObjSafe = (options: AnySelectOption[]) => {
        setAllInstalationsObj(
            options.map(opt => ({
                ...opt,
                value: Number(opt.value)
            }))
        );
    }
    const [selectedInstalation, setSelectedInstalation] = useState<ISelectOptions>({ label: '', value: 0 })
    const [iniDate, setIniDate] = useState(getLast7days())
    const [finDate, setFinDate] = useState(getTodayDate())
    const [loadingData, setLoadingData] = useState(true)

    const { idinstalation } = useParams();
    const context: IOutletContext = useOutletContext();
    const { t } = useTranslation();
    const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1000);
    const theme = useTheme()

    useEffect(() => {
        const handleResize = () => {
            setIsWideScreen(window.innerWidth > 1000);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        context.setState(t('Installations'))
    })

    const tableHeaders = [t('Date'), t('Machine'), t('Installation'), t('Operation')]
    const tableBody: TableData[] = [
        { item: [1, format(new Date().setHours(new Date().getHours() - 1), 'dd/MM/yyyy HH:mm'), 'Equipo 1', 'Awayter', 'Product 1'], active: true },
        { item: [2, format(new Date().setHours(new Date().getHours() - 2), 'dd/MM/yyyy HH:mm'), 'Equipo 3', 'Jaén 232', 'Product 2'], active: true },
        { item: [3, format(new Date().setHours(new Date().getHours() - 3), 'dd/MM/yyyy HH:mm'), 'Equipo 5', 'Lleida 261', 'Product 3'], active: true },
        { item: [4, format(new Date().setHours(new Date().getHours() - 4), 'dd/MM/yyyy HH:mm'), 'Equipo 3', 'Salamanca 762', 'Product 4'], active: true },
        { item: [5, format(new Date().setHours(new Date().getHours() - 5), 'dd/MM/yyyy HH:mm'), 'Equipo 2', 'Lisboa 596', 'Product 5'], active: true },
        { item: [6, format(new Date().setHours(new Date().getHours() - 6), 'dd/MM/yyyy HH:mm'), 'Equipo 7', 'Budapest 854', 'Product 6'], active: true },
        { item: [7, format(new Date().setHours(new Date().getHours() - 7), 'dd/MM/yyyy HH:mm'), 'Equipo 8', 'Berlín 845', 'Product 7'], active: true },
        { item: [8, format(new Date().setHours(new Date().getHours() - 8), 'dd/MM/yyyy HH:mm'), 'Equipo 6', 'Roma 426', 'Product 8'], active: true },
        { item: [9, format(new Date().setHours(new Date().getHours() - 9), 'dd/MM/yyyy HH:mm'), 'Equipo 5', 'Awayter', 'Product 9'], active: true }]

    const getCharData = (): charData[] => {
        const charData: charData[] = []
        const now = new Date()
        now.setDate(now.getDate() - 6)
        for (let i = 0; i < 7; i++) {
            charData.push({ date: `${now.getDate()}/${now.getMonth() + 1}`, numItems: getRandomNumber(0, 100) })
            now.setDate(now.getDate() + 1)
        }

        return charData
    }

    // useEffect(() => {
    //     if (loadingData && instalation.idinstalation > 0) {
    //         getLastData(user.token, instalation.idinstalation, DashboardTypes.MachineGroup)
    //             .then((md: MachineData) => setData(md))
    //             .catch((e) => console.error('Error getLastData', e))
    //             .finally(() => {
    //                 setTimeout(() => {
    //                     setLoadingData(false)
    //                 }, 250)
    //             })
    //         getAllDataByDates(user.token, instalation.idinstalation, iniDate, finDate, DashboardTypes.MachineGroup)
    //             .then((md: MachineData[]) => setAllData(md))
    //             .catch((e) => console.error('Error getAllDataByDates', e))
    //             .finally(() => {
    //                 setTimeout(() => {
    //                     setLoadingData(false)
    //                 }, 250)
    //             })
    //     }

    // }, [loadingData, instalation])

    useEffect(() => {
        getInstalationsByCompany(user.token, user.company.idcompany)
            .then((c: Instalation[]) => {
                if (c.length === 0) { throw new Error('No Containers') }
                setInstalations(c)
                const cObj = orderByLabel(c.map((i: Instalation) => ({ label: i.name, value: Number(i.idinstalation) })))
                const lastInstallationIdSelected = localStorage.getItem('lastInstallationIdSelected')
                const rawSelectedId = idinstalation || lastInstallationIdSelected
                const normalizedSelectedId = rawSelectedId ? Number(rawSelectedId) : Number(cObj[0].value)

                const selectedInstalationFound = c.find((i: Instalation) => i.idinstalation === normalizedSelectedId)
                const selectedContainerAux = selectedInstalationFound
                    ? { label: selectedInstalationFound.name, value: Number(selectedInstalationFound.idinstalation) }
                    : { label: cObj[0].label, value: Number(cObj[0].value) }

                setSelectedInstalation({ label: selectedContainerAux.label, value: Number(selectedContainerAux.value) })
                setAllInstalationsObjSafe(cObj)
                localStorage.setItem('lastInstallationIdSelected', selectedContainerAux.value.toString());
            }).catch((e) => {
                console.error('Error getInstalationsByCompany', e)
            }).finally(() => { setTimeout(() => { setLoadingData(false) }, 250) })
    }, [])

    useEffect(() => {
        const instalationAux: Instalation | undefined = instalations.find((i: Instalation) => i.idinstalation === selectedInstalation?.value);
        if (instalationAux) {
            setLoadingData(true)
            setInstalation(instalationAux)
            setTimeout(() => { setLoadingData(false) }, 250)
        }

        const interval = setInterval(() => {
            setLoadingData(true)
            setTimeout(() => { setLoadingData(false) }, 500)
        }, 300000) //300000 -> 5min   30000 -> 30s

        return (() => {
            clearInterval(interval)
        })
    }, [selectedInstalation, instalations])

    const selectInstallation = (selected: ISelectOptions) => {
        setSelectedInstalation(selected)
        localStorage.setItem('lastInstallationIdSelected', selected.value.toString());
    }

    // eslint-disable-next-line 
    const onChangeCombo = (e: any) => {
        const selectedValue = allInstalationsObj.find((c: ISelectOptions) => c.value === parseInt(e.value));
        if (selectedValue) selectInstallation({ label: selectedValue.label, value: Number(selectedValue.value) })
    }
    // eslint-disable-next-line 
    const onChangeDates = (e: any) => {
        if (e.target.name === "iniDate") {
            setIniDate(e.target.value)
        } else if (e.target.name === "finDate") {
            setFinDate(e.target.value)
        }
    }

    const onClickRefresh = () => {
        setLoadingData(true)
        setTimeout(() => { setLoadingData(false) }, 500)
    }



    return (
        <>
            <div className='row border-0 mx-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-md-12 p-1'>
                    <UserButtonsLine
                        downloardData={() => null}
                        role={user.role}
                        connected={MachineConected.Conected}
                        defaultIni={iniDate}
                        defaultFin={finDate}
                        onChangeDates={onChangeDates}
                        onClickReload={onClickRefresh}
                        onChangeSelect={onChangeCombo}
                        options={allInstalationsObj}
                        selected={selectedInstalation}
                        DashboardType={DashboardTypes.MachineGroup}
                        changeView={() => null}
                        classNameSecondary='btn-Custom btn-IDGrey'
                        classNameSuccess='btn-Custom btn-IDGreen'
                        containerColor='var(--background-secondary)'
                        dark={theme.theme === 'dark' ? true : false}
                        downloadButton={false} />
                </div>
            </div>
            <div className='row border-0 ms-2 me-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-sm-5 col-lg-4 px-1 mt-1'>
                    <MachineStatus updLastConnection={() => null} id={instalation.idinstalation} token={user.token} refresh={loadingData} title={t('Status')} dashboardType={DashboardTypes.MachineGroup} user={user} iniDate={iniDate} finDate={finDate} />
                </div>
                <div className='col-12 col-sm-7 col-md mb-1 mb-sm-0 px-1 mt-1'>
                    <AwCarousel items={instalation.machines} rows={1} cols={isWideScreen ? 2 : 1} activePageIndicatorColor="var(--accent-color)"
                        footerColor="var(--background-secondary)" >
                        {(item: Machine) => <MachineCard key={item.idmachine} machine={item} refresh={loadingData} />}
                    </AwCarousel>
                </div>
            </div>
            <div className='row border-0 ms-2 me-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-md-4 px-1 mt-2'>
                    <AWGrid loading={loadingData} noDataText={t('NoData')} onDeleteClick={() => null} onEditClick={() => null} tableData={tableBody}
                        tableHeaders={tableHeaders} bgColor="var(--background-secondary)" textColor="var(--text-primary)" title={t('Operations')} manage={false} gridStyle="gridsStyle" spinnerColor="var(--accent-color)" />
                </div>
                {/* <div className='col-12 col-md-1 mt-1 p-1'>
                    <KPIs refresh={loadingData} token={user.token} role={user.role} idmachine={1} title={t('KPI')} data={data.quality || 0} color={1} units='%' />
                </div> */}
                <div className='col-12 col-md-8 mt-1 p-1'>
                    <CharD3 dataChar={getCharData()} loading={loadingData} capture={false} title={t('OperationsForDay')} setPNGChar={() => null} />
                </div>
            </div>
            <div className='row border-0 ms-2 me-2 mb-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-md-12 p-1'>
                    <div className='p-2 rounded-1' style={{ backgroundColor: 'var(--background-secondary)', height: '500px', width: '100%', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)' }}>
                        {loadingData ? <div className="text-center pt-5"><Spinner animation="border" variant="success" /></div> :
                            <MapComponent url={'userInstalations'} allPositions={[{ lat: instalation.lat, lng: instalation.lng, id: instalation.idinstalation, name: instalation.name, iconColor: '#008000', letter: '1' }]} enable={true} position={{ lat: instalation.lat, lng: instalation.lng }}
                                setPosition={() => { return false }} showAllPositions={true} iconSize={30} />}
                    </div>
                </div>
            </div>
        </>



    )
}

export default UserInstalationsPage